<div class="preview-stamp" *ngIf="visible">
  <span class="stamp" (click)="goToJob()">
    Job Preview
    <div class="subtitle">Start to edit</div>
  </span>
</div>